<template>
  <div class="info-panel column main is-5">
    <div class="panel info-panel">
      <div class="panel-block title">
        {{ displayType(fireProtection) }}
      </div>

      <div class="panel-block block">
        <p class="label">{{ $t('firepanel.type') }}</p>
        <div class="box">
          <span
            class="fireprotection-icon"
            aria-hidden="true"
            style="vertical-align: middle; display:inline-block; width:24px; height:24px; margin-right:6px;"
          />
          {{ displayType(fireProtection) }}
        </div>
      </div>

      <div class="panel-block block">
        <p class="label">{{ $t('firepanel.recommendation') }}</p>
        <div class="box">{{ fireProtection.recommendation || '—' }}</div>
      </div>

      <div class="panel-block block">
        <p class="label">{{ $t('firepanel.instruction') }}</p>
        <div class="box">{{ tInstruction(fireProtection.instruction) || '—' }}</div>
      </div>

      <div class="panel-block block">
        <p class="label">{{ $t('firepanel.description') }}</p>
        <div class="box">{{ tDescription(fireProtection.description) || '—' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';

export default {
  mixins: [iconMixin],
  props: {
    fireProtection: { type: Object, required: true },
  },
};
</script>

<style scoped>
.fireprotection-icon {
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
